export default (value) => {
  const formatter = Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR'
  })
  // let money = parseFloat(value).toFixed(2) + ' €'
  // return money.replace('.', ',')
  return formatter.format(value)
}



// WEBPACK FOOTER //
// ./src/filters/money.js